import { NO_VALUE_DISPLAY } from "../../constants";

/** Formats entity label as "Name (id)" when both exist; falls back to name or "(id)". */
export const formatPassengerTooltipEntityWithId = ({
  name,
  id,
}: {
  name?: string;
  id?: number | null;
}): string | undefined => {
  const hasId = id !== null && id !== undefined && Number(id) > 0;
  const trimmedName = name?.trim();

  if (trimmedName && hasId) {
    return `${trimmedName} (${id})`;
  }
  if (trimmedName) {
    return trimmedName;
  }
  if (hasId) {
    return `(${id})`;
  }
  return undefined;
};

export const getPassengerTooltipStationTitleParts = ({
  title,
  areaName,
}: {
  title?: string;
  areaName?: string;
}): { title: string; areaName?: string } => {
  const trimmedArea = areaName?.trim();

  return {
    title: title?.trim() || NO_VALUE_DISPLAY,
    areaName: trimmedArea || undefined,
  };
};
